import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
  variant?: 'default' | 'large' | 'small';
}

export default function ComicCard({ comic, variant = 'default' }: ComicCardProps) {
  const isLarge = variant === 'large';
  const isSmall = variant === 'small';

  return (
    <Link
      to={`/comic/${comic.id}`}
      className="group block cursor-pointer"
    >
      <div className={`relative overflow-hidden rounded-xl bg-background-100 transition-all duration-300 group-hover:scale-[1.02] ${
        isLarge ? 'aspect-[3/4]' : isSmall ? 'aspect-[2/3]' : 'aspect-[3/4]'
      }`}>
        <img
          src={comic.cover}
          alt={comic.title}
          title={`${comic.title} - 无删减韩国漫画`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />

        {comic.status && (
          <span className={`absolute top-3 right-3 px-2.5 py-1 rounded-full text-[10px] font-label whitespace-nowrap ${
            comic.status === '连载中'
              ? 'bg-accent-500/90 text-background-50'
              : 'bg-background-950/70 text-foreground-200'
          }`}>
            {comic.status}
          </span>
        )}

        {comic.isHot && (
          <span className="absolute top-3 left-3 px-2 py-0.5 rounded-full text-[10px] font-label bg-primary-500 text-background-50 whitespace-nowrap">
            HOT
          </span>
        )}

        {comic.isNew && !comic.isHot && (
          <span className="absolute top-3 left-3 px-2 py-0.5 rounded-full text-[10px] font-label bg-accent-500 text-background-50 whitespace-nowrap">
            NEW
          </span>
        )}

        <div className="absolute bottom-0 left-0 right-0 p-3 md:p-4">
          <h3 className="text-sm md:text-base font-semibold text-foreground-50 line-clamp-1 mb-1">
            {comic.title}
          </h3>
          {!isSmall && (
            <div className="flex items-center gap-2 text-[11px] text-foreground-300">
              <span className="flex items-center gap-1">
                <i className="ri-eye-line text-xs"></i>
                {comic.views}
              </span>
              <span className="text-foreground-500">·</span>
              <span className="flex items-center gap-1">
                <i className="ri-star-fill text-xs text-primary-500"></i>
                {comic.rating}
              </span>
            </div>
          )}
        </div>
      </div>
      {!isSmall && (
        <div className="mt-2 px-1">
          <p className="text-xs text-foreground-500 truncate">{comic.author} / {comic.artist}</p>
        </div>
      )}
    </Link>
  );
}